import script from "./AiRecommendation.vue?vue&type=script&setup=true&lang=js"
export * from "./AiRecommendation.vue?vue&type=script&setup=true&lang=js"

import "./AiRecommendation.vue?vue&type=style&index=0&id=75771bf7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75771bf7"]])

export default __exports__